import Vue from 'vue'
import Router from 'vue-router'
import login from "../views/login.vue"
import home from "../views/home.vue"

//推荐表
import menu1 from "../views/page/menu1.vue"
import menu2 from "../views/page/menu2.vue"
import menu3 from "../views/page/menu3.vue"
//分公司开户表
import filiale1 from "../views/page/filiale1.vue"
import filiale2 from "../views/page/filiale2.vue"
//排名表
import rank1 from "../views/page/rank1.vue"
import rank2 from "../views/page/rank2.vue"
import rank3 from "../views/page/rank3.vue"
//客户全量数据表
import client1 from "../views/page/client1.vue"
import client2 from "../views/page/client2.vue"
import client3 from "../views/page/client3.vue"
//内勤员工名单
import indoor1 from "../views/page/indoor1.vue"
import indoor2 from "../views/page/indoor2.vue"
import indoor3 from "../views/page/indoor3.vue"
import indoor4 from "../views/page/indoor4.vue"
//积分管理
import organization1 from "../views/page/organization1.vue"
import organization2 from "../views/page/organization2.vue"
import organization3 from "../views/page/organization3.vue"

//富文本编辑器
import useUe from "../views/page/useUe.vue"

//存款分级数据表
import depositList1 from "../views/page/depositList1.vue"
import depositList2 from "../views/page/depositList2.vue"
import depositList3 from "../views/page/depositList3.vue"
import depositList4 from "../views/page/depositList4.vue"
import depositList5 from "../views/page/depositList5.vue"
import depositList6 from "../views/page/depositList6.vue"
import depositList7 from "../views/page/depositList7.vue"
import depositList8 from "../views/page/depositList8.vue"
import depositList9 from "../views/page/depositList9.vue"
import depositList10 from "../views/page/depositList10.vue"
import depositList11 from "../views/page/depositList11.vue"
import depositList12 from "../views/page/depositList12.vue"
import depositList13 from "../views/page/depositList13.vue"
import depositList14 from "../views/page/depositList14.vue"
import depositList15 from "../views/page/depositList15.vue"
import depositList16 from "../views/page/depositList16.vue"
//每日数据表
import everydayData1 from "../views/page/everydayData1.vue"
import everydayData2 from "../views/page/everydayData2.vue"
//贷款数据表
import loans1 from "../views/page/loans1.vue"
import loans2 from "../views/page/loans2.vue"
import loans3 from "../views/page/loans3.vue"
import loans4 from "../views/page/loans4.vue"
import loans5 from "../views/page/loans5.vue"
import loans6 from "../views/page/loans6.vue"
import loans7 from "../views/page/loans7.vue"
//VIP专区
import venusZone1 from "../views/page/venusZone/venusZone1.vue"
import venusZone2 from "../views/page/venusZone/venusZone2.vue"
//各机构数据
import filialePower1 from "../views/page/filialePower/filialePower1.vue"
import filialePower2 from "../views/page/filialePower/filialePower2.vue"
import filialePower3 from "../views/page/filialePower/filialePower3.vue"

//数据上传
import message1 from "../views/page/messageUpdate/message1.vue"
// 订单查询
import message2 from "../views/page/messageUpdate/message2.vue"
// 合同查询
import message3 from "../views/page/messageUpdate/message3.vue"

//PC端商城
import shopIndex from "../views/page/shopPC/shopIndex.vue"
import shopLogin from "../views/page/shopPC/shopLogin.vue"
import shopRegister from "../views/page/shopPC/shopRegister.vue"
import shopNews from "../views/page/shopPC/shopNews.vue"
import shopEnter from "../views/page/shopPC/shopEnter.vue"


Vue.use(Router)


var router = new Router({
  mode:'hash',
  base: "/main/",
  
  routes:[
    // { path: '/', redirect: { name: '二级单位数据表' }, hidden: true },
    { path: '/', redirect: { name: 'e金科商城' }, hidden: true },
    {
      path: '/',//商城首页
      name: 'e金科商城',
      component: shopIndex,
      hidden: true,
    },
    {
      path: '/login',//登录页
      name: '',
      component: login,
      // hidden: true 
    },
    // {
    //   path: '/hello',//登录页
    //   name: 'hello',
    //   component: hello,
    //   hidden: true 
    // },
    {
      path: '/home',//首页
      component: home,
      name: '推荐开户表',
      
        iconCls: '', //图标样式class
        children: [{
            path: 'menu1',
            component: menu1,
            name: '推荐开户数'
          },
          {
            path: 'menu2',
            component: menu2,
            name: '推荐开户明细'
          },
          {
            path: 'menu3',
            component: menu3,
            name: '推荐关系明细表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '分公司开户表',
        iconCls: '', //图标样式class
        children: [{
            path: 'filiale1',
            component: filiale1,
            name: '分公司开户进度明细表'
          },
          {
            path: 'filiale2',
            component: filiale2,
            name: '分公司开户进度表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '排名表',
        iconCls: '', //图标样式class
        children: [{
            path: 'rank1',
            component: rank1,
            name: '中支排名表'
          },
          {
            path: 'rank2',
            component: rank2,
            name: '营服排名表'
          },
          {
            path: 'rank3',
            component: rank3,
            name: '个人排名表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '客户数据表',
        iconCls: '', //图标样式class
        children: [{
            path: 'client1',
            component: client1,
            name: '客户全量数据表'
          },
          {
            path: 'client2',
            component: client2,
            name: '关注注册开户分析表'
          },
          {
            path: 'client3',
            component: client3,
            name: '点击量汇总表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '员工信息',
        iconCls: '', //图标样式class
        children: [{
            path: 'indoor1',
            component: indoor1,
            name: '员工信息详情表'
          },
          {
            path: 'indoor2',
            component: indoor2,
            name: '个险外勤开户明细表'
          },
          {
            path: 'indoor3',
            component: indoor3,
            name: '员工个人开户排名表前50名'
          },
          {
            path: 'indoor4',
            component: indoor4,
            name: '营服排名表前50名'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '积分管理',
        iconCls: '', //图标样式class
        children: [{
            path: 'organization1',
            component: organization1,
            name: '机构负责人金蟾豆列表'
          },
          {
            path: 'organization2',
            component: organization2,
            name: '金蝌豆明细表(一)',//不含员工自己存款奖励
          },
          {
            path: 'organization3',
            component: organization3,
            name: '金蝌豆明细表(二)',//包含员工自己存款奖励
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '每日数据表',
        iconCls: '', //图标样式class
        children: [{
            path: 'everydayData1',
            component: everydayData1,
            name: '每日注册数据表'
          },
          {
            path: 'everydayData2',
            component: everydayData2,
            name: '每日推荐明细表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '贷款数据表',
        iconCls: '', //图标样式class
        children: [{
            path: 'loans1',
            component: loans1,
            name: '贷款分析表'
          },
          {
            path: 'loans2',
            component: loans2,
            name: '逾期日报'
          },
          {
            path: 'loans3',
            component: loans3,
            name: '历史逾期数据表'
          },
          {
            path: 'loans4',
            component: loans4,
            name: '贷款放款信息表'
          },
          {
            path: 'loans5',
            component: loans5,
            name: '贷款还款信息表'
          },
          {
            path: 'loans6',
            component: loans6,
            name: '保单贷授信申请表'
          },
          {
            path: 'loans7',
            component: loans7,
            name: '保单贷授信结果表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '存款数据表',
        iconCls: '', //图标样式class
        children: [{
            path: 'depositList1',
            component: depositList1,
            name: '分公司存款分级数据表'
          },
          {
            path: 'depositList2',
            component: depositList2,
            name: '中支存款分级数据表'
          },
          {
            path: 'depositList3',
            component: depositList3,
            name: '营服存款分级数据表'
          },
          {
            path: 'depositList4',
            component: depositList4,
            name: '存款统计表'
          },
          {
            path: 'depositList5',
            component: depositList5,
            name: '推荐人明细表'
          },
          {
            path: 'depositList6',
            component: depositList6,
            name: '推荐人分析表'
          },
          {
            path: 'depositList7',
            component: depositList7,
            name: '专属福利达成进度表'
          },
          {
            path: 'depositList12',
            component: depositList12,
            name: '专属福利总额表（综拓参考）'
          },
          {
            path: 'depositList8',
            component: depositList8,
            name: '中支排名周报'
          },
          {
            path: 'depositList9',
            component: depositList9,
            name: '营服排名周报'
          },
          {
            path: 'depositList10',
            component: depositList10,
            name: '业务员排名周报'
          },
          {
            path: 'depositList11',
            component: depositList11,
            name: '分公司奖励月报'
          },
          {
            path: 'depositList13',
            component: depositList13,
            name: '存款总额明细表108'
          },
          {
            path: 'depositList14',
            component: depositList14,
            name: '分公司存款总额数据表108'
          },
          {
            path: 'depositList15',
            component: depositList15,
            name: '中支存款总额数据表108'
          },
          {
            path: 'depositList16',
            component: depositList16,
            name: '营服存款总额数据表108'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '编辑器',
        iconCls: '', //图标样式class
        children: [{
            path: 'useUe',
            component: useUe,
            name: '富文本编辑器'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: 'VIP专区',
        iconCls: '', //图标样式class
        children: [{
            path: 'venusZone1',
            component: venusZone1,
            name: '申请信息'
          },
          {
            path: 'venusZone2',
            component: venusZone2,
            name: '历史客户'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '各机构数据',
        iconCls: '', //图标样式class
        children: [{
            path: 'filialePower1',
            component: filialePower1,
            name: '二级单位数据表'
          },
          {
            path: 'filialePower2',
            component: filialePower2,
            name: '三级单位数据表'
          },
          {
            path: 'filialePower3',
            component: filialePower3,
            name: '四级单位数据表'
          },
        ]
    },
    {
      path: '/',//首页
      component: home,
      name: '数据上传',
        iconCls: '', //图标样式class
        children: [{
            path: 'message1',
            component: message1,
            name: '数据上传'
          },
          {
            path: 'message2',
            component: message2,
            name: '订单查询'
          },
          {
            path: 'message3',
            component: message3,
            name: '合同查询'
          },
      ]
    },
    // {
    //   path: '/shopIndex',//商城首页
    //   name: 'e金科商城',
    //   component: shopIndex,
    //   hidden: true,
    // },
    {
      path: '/shopLogin',//商城登录页
      name: '登录',
      component: shopLogin,
    },
    {
      path: '/shopRegister',//商城注册页
      name: '注册',
      component: shopRegister,
    },
    {
      path: '/shopNews',//商城资讯页
      name: '资讯',
      component: shopNews,
    },
    {
      path: '/shopEnter',//商家入驻流程
      name: '入驻流程',
      component: shopEnter,
    },
    
  ]
})
//监听路由，在路由切换前将上个页面的请求取消
router.beforeEach((to, from, next) => {
  window._axiosPromiseArr.forEach((ele,index) => {
	ele.cancel() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
	// 清空请求的参数
	delete window._axiosPromiseArr[index]
 })
 next()
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js